import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { IconButton } from '../button';
import { IconSearch } from '../icon';
import { styled } from '../styled';
import { Autocomplete } from './index';
export const SearchAutocomplete = ({ size = 'medium', value, loading, popperWidth, placeholder, slotProps: _slotProps = {}, onInputChange, onInputClear, onSelect, onDeselect, options, ...props }) => {
    const [text, setText] = React.useState('');
    const clearInput = () => {
        setText('');
        onInputClear();
    };
    const startAdornment = _jsx(IconSearch, {});
    const endAdornment = props.disabled ? null : (_jsx(IconButton, { icon: "IconClose", size: "small", onClick: () => {
            clearInput();
            if (value) {
                onDeselect();
            }
        }, loading: loading, sx: value || text
            ? undefined
            : { visibility: 'hidden', pointerEvents: 'none' }, "data-role": "clear" }));
    const StyledAutocomplete = React.useMemo(() => StyledAutocompleteFactory(), []);
    const slotProps = {
        ..._slotProps,
        input: { startAdornment, endAdornment }
    };
    return (_jsx(StyledAutocomplete, { clearOnBlur: true, clearOnEscape: true, blurOnSelect: true, autoHighlight: false, filterOptions: (options) => options, ...props, inputValue: text, options: options ?? [], open: Boolean(text), placeholder: value ?? placeholder, inputMode: "search", onChange: (option) => {
            if (option) {
                onSelect(option);
            }
        }, onInputChange: (_event, value, reason) => {
            if (reason !== 'input') {
                return;
            }
            setText(value);
            onInputChange(value);
        }, onClose: clearInput, forcePopupIcon: false, "$opacity": Boolean(value), "$size": size, slotProps: popperWidth
            ? {
                ...slotProps,
                popper: {
                    ...slotProps.popper,
                    style: {
                        width: popperWidth,
                        maxWidth: '95%'
                    },
                    placement: 'bottom-end'
                }
            }
            : slotProps, onBlur: clearInput }));
};
const StyledAutocompleteFactory = () => styled((Autocomplete)) `
    .MuiFormControl-root
        > .MuiInputBase-root.MuiOutlinedInput-root.MuiAutocomplete-inputRoot {
        padding: ${({ $size, theme }) => [
    theme.spacing($size === 'small' ? 0.75 : 1),
    theme.spacing($size === 'small' ? 1.25 : 0.75)
]};
    }
    .MuiInputBase-root input::placeholder {
        ${({ $opacity }) => ($opacity ? 'opacity: 1;' : '')}
    }
`;
